const WelcomeCard = ({ onGetStarted }) => {
    return (
        <div className="card flex col space r1-1 margin-top--large">
            <p className="large">Welcome to PocketWatch</p>
            <p className="medium margin-top--large">Add your first asset or liability.</p>
            <button className="button large margin-top--large" onClick={onGetStarted}>Let's begin</button>
        </div>
    );
};

export default WelcomeCard;
